import React from 'react';
import { Spinner, Alert } from 'react-bootstrap';
import { useEticketingRoutePricesQuery, useEticketingTimingsQuery } from '../../../../api/e-ticketing/e-ticketing.hooks';
import { emojis } from '../../bootstrap/alertData';
import RoutePriceForm from './RoutePriceForm';
import RouteTimingForm from './RouteTimingForm';

const RoutePrices = ({ routeId }) => {
  // route prices hooks
  const { data: pricesData, isLoading: pricesLoading, error: pricesError, refetch: refetchPrices } = useEticketingRoutePricesQuery({ route_id: routeId });

  // timings hooks
  const { data: timingsResponse, isLoading: timingsLoading, error: timingsError, refetch: refetchTimings } = useEticketingTimingsQuery({ route_id: routeId });

  const prices = pricesData?.prices || [];
  const timings = timingsResponse?.timings || [];

  if (pricesLoading || timingsLoading) {
    return (
      <div className="d-flex justify-content-center align-items-center p-5">
        <Spinner animation="border" role="status" />
        <span className="ms-2">Loading data...</span>
      </div>
    );
  }

  return (
    <div>
      {/* Route Prices Section */}
      <div className="mb-4">
        {pricesError ? (
          <Alert variant="danger">
            {emojis.warning} Failed to load route prices.
          </Alert>
        ) : (
          <RoutePriceForm 
            prices={prices} 
            routeId={routeId} 
            onRefresh={refetchPrices}
          />
        )}
      </div>

      {/* Route Timings Section */}
      <div>
        {timingsError ? (
          <Alert variant="danger">
            {emojis.warning} Failed to load route timings.
          </Alert>
        ) : (
          <RouteTimingForm 
            timings={timings} 
            routeId={routeId} 
            onRefresh={refetchTimings}
          />
        )}
      </div>
    </div>
  );
};

export default RoutePrices;